import React from "react";
import "./newsPapeperPopUp.scss";
import Modal from "react-awesome-modal";
import { currencyFormat } from "../utilities/utils";

export const NewsPaperPopUp = (props) => {

  return (
    <div className="news-paper-popup">
      <Modal
        visible={props.visible}
        width="400"
        className="popup-modal"
        effect="fadeInUp"
        onClickAway={() => props.closeModal()}
      >
        <div>
          <div className="popup">
            <h2 className="block-title">More Details</h2>
            <hr />
            <div className="popup-block">
              <div className="content-block">
                <p className="first-content">Color Type</p>
                <p className="second-content">{props.more.color_type}</p>
              </div>
              <div className="content-block">
                <p className="first-content">Publish Cost</p>
                <p className="second-content">
                  Rs.{currencyFormat(props.more.actual_price)}
                </p>
              </div>
              <div className="content-block">
                <p className="first-content">Discount</p>
                <p className="second-content">
                  <i class="bx bx-minus-circle"></i>
                  Rs.{currencyFormat(props.more.discount_price)}
                </p>
              </div>
              <div className="content-block">
                <p className="first-content">VAT Price(13%)</p>
                <p className="second-content">
                  <i class="bx bx-plus-circle"></i>
                  Rs.{currencyFormat(props.more.vat_price)}
                </p>
              </div>
              <hr />
              <div className="content-block total">
                <p className="first-content ">Total price</p>
                <p className="second-content">
                  Rs.{currencyFormat(props.more.publish_price)}
                </p>
              </div>
            </div>

            <a href="javascript:void(0);" onClick={() => props.closeModal()}>
              <div className="close-icon">
                <i className="bx bx-x"></i>
              </div>
            </a>
          </div>
        </div>
      </Modal>
    </div>
  );
};
